<div *ngIf="!showSpinner" style='margin: 30px; margin-top: 3rem;'>
    <div class="invalid-feedback d-flex flex-row align-items-center justify-content-center text-center">
      <span *ngIf="errorMessage">{{errorMessage}}</span>
      <span *ngIf="invalidDateRangeError">
       &nbsp; {{invalidDateRangeError}}
      </span>
      <span *ngIf="dateExceedsOneYearError">
      &nbsp; {{dateExceedsOneYearError}}
      </span>
    </div>
  <div class="d-flex flex-row pe-4">
    <form [formGroup]="reportForm" (ngSubmit)="onRequestReport(reportForm)" style='width: 100%;'>
      <div *ngIf="selectedTab === 'Report Criteria'">
        <div class="row g-4 my-1 pe-4">
          <!-- Report Type -->
          <div class="col-md-6 d-flex align-items-center">
            <span class="myview-view-label me-3 mb-0">Report Type:</span>
            <p-dropdown class="drop-down" [options]="reportTypeList" [styleClass]="'standardDropdownStyle'"
              optionLabel="value" formControlName="reportType" [ngClass]="{'standardDropdownStyle-open': isDropdownOpen}" (onShow)="isDropdownOpen = true" (onHide)="isDropdownOpen = false">
            </p-dropdown>
          </div>
          <!-- Date Range -->
          <div class="col-md-6 d-flex align-items-center">
            <span class="myview-view-label me-3 mb-0">Start Date:</span>
            <div class="d-flex gap-3 flex-wrap me-4">
              <!-- Start Date -->
              <p-calendar formControlName="startDate" inputStyleClass="custom-width" class="custom-calender" dateFormat="dd/mm/yy"
                [iconDisplay]="'input'" inputId="icondisplay" [appendTo]="'body'" [monthNavigator]="true"
                [placeholder]="'DD/MM/YYYY'" [showOtherMonths]="true"  [showIcon]="true"
                [minDate]="minDate" [maxDate]="startMaxDate" [readonlyInput]="true" />
            </div>
            <span class="myview-view-label me-3 mb-0">End Date:</span>
            <div class="d-flex gap-3 flex-wrap">
              <!-- End Date -->
              <p-calendar formControlName="endDate" inputStyleClass="custom-width" class="custom-calender" dateFormat="dd/mm/yy"
                [iconDisplay]="'input'" inputId="icondisplay" [appendTo]="'body'" [monthNavigator]="true"
                [placeholder]="'DD/MM/YYYY'" [showOtherMonths]="true" [showIcon]="true"
                [maxDate]="maxDate" [readonlyInput]="true" />

            </div>

          </div>

        </div>
        <div class="d-flex flex-row mt-3">
          <div class="mb-1 myview-view-label me-3">
            Select Group
          </div>
          <div class="d-flex flex-column flex-nowrap myviews-elem">
            <div>
              <app-checkbox-list [placeholder]="'Quick Search...'" [name]="'groups'" [items]="assignedGroups"
                [enableSelectAll]="true" [listStyle]="{'height':'310px'}" (onItemSelect)="getAssignedGroups($event)"
                [resetBehaviour]="true" (onSelectAll)="handleSelectAll($event)"></app-checkbox-list>
            </div>
          </div>
        </div>

        <div class="success-feedback" *ngIf="successMessage">
          <span>{{successMessage}}</span>
        </div>
      </div>

      <p-footer style="width: 69.7%;top:40em;margin-left: -5px;">
        <div class="d-flex flex-row footer-btn-container"></div>
        <div class="d-flex flex-row flex-wrap bottom-button-holder px-3 pb-2 pt-3 justify-content-end">
          <button type="button" class="btn clear-btn me-4" (click)="clearAndClose(reportForm)">Cancel</button>
          <button type="submit" class="btn save-btn">Request</button>
        </div>
      </p-footer>
    </form>
  </div>
</div>

<ngx-loading *ngIf="showSpinner" [show]="showSpinner" [config]="{ backdropBorderRadius: '3px' }"
  [template]="customLoadingTemplate">
</ngx-loading>
<ng-template #customLoadingTemplate>
  <div class="custom-class-loader">
    <div class="spinner-container">
      <img src="assets/qwyn/icons/spinner.gif" alt="Loading" class="loader">
    </div>
  </div>
</ng-template>